module.exports = __webpack_public_path__ + "img/member_banner.bb31361f.png";